export default __webpack_public_path__ + "static/media/BI.c6a1308d.svg";